function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  d: "M132.6,6H14.9c-4.2,0-7.6,3.4-7.6,7.6v65.7c0,4.2,3.4,7.6,7.6,7.6h117.8c4.2,0,7.6-3.4,7.6-7.6V13.6 C140.2,9.4,136.8,6,132.6,6z M48.5,69.1c-1.3,3-3.1,5.1-5.5,6.6c-2.4,1.4-5.3,2.2-8.8,2.2c-5.1,0-8.8-1.9-11.8-5.2 C20,70,20,68.1,19.1,64.8l9.3,0.3c1.5,1.8,3.4,2.7,5.9,2.7c2.6,0,4.6-0.8,5.9-2.4c1.3-1.6,2-3.5,2-5.7c0-1.4-0.3-2.6-0.8-3.6 c-0.6-1-1.5-1.8-2.9-2.6c-1-0.5-3.1-1.3-6.5-2.6c-4.4-1.6-7.5-3.5-9.2-5.8c-2.5-3.2-3.7-7.2-3.7-11.9c0-3,0.6-5.8,1.8-8.4 c1.2-2.6,2.9-4.6,5.1-6c2.2-1.4,4.9-2.1,8-2.1c5.1,0,8.9,1.6,11.5,4.9l-6.4,7c-1.2-1.3-2.9-2-5.2-2c-2.4,0-4.2,0.7-5.6,2.1 c-0.9,0.9-1.3,2.1-1.3,3.7c0,1.4,0.4,2.6,1.2,3.6c1,1.3,3.5,2.6,7.5,3.9c4,1.4,6.9,2.8,8.8,4.2c1.9,1.5,3.4,3.5,4.5,6 s1.6,5.7,1.6,9.4C50.5,63,49.8,66.2,48.5,69.1z M89.2,76.8H58.5v-59h30v10H66.6v13.1H87v9.9H66.6v16.1h22.6V76.8z M126.6,27.8h-12 v49h-8.2v-49h-12v-10h32.2V27.8z"
});

var SvgSetIcon = function SvgSetIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 150 92.8",
    style: {
      enableBackground: "new 0 0 150 92.8"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSetIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/set-icon.fc849836.svg";
export { ForwardRef as ReactComponent };